export const notificationKeys = {
  title: 'title',
  description: 'description',
  date: 'date',
  read: 'read',
  userImage: 'userImage',
  brandId: 'brandId',
  link: 'link',
};
